import {defineAppContext} from '@malt/vue-context';
import {NotificationsResource, UserResource} from '@//common/api';
import {useUser} from '@/logged/features/user';
import {useNotifications} from '@/logged/features/notifications';

export const {createEndpoint, loadApiContext, useAppContext, getEndpointUrl, endpointExists} = defineAppContext({
    baseUrl: '/api/navbar/registry',
    defaultState: {
        _links: [],
        loading: false,
    },
    entries: ['user', 'selectIdentity', 'changeNavbarState', 'notifications', 'acknowledgeOnboarding'],
    async onResolvedContext({createEndpoint, pinia}) {
        const userStore = useUser(pinia);
        const getUser = createEndpoint<UserResource>('user');

        const notificationsStore = useNotifications();
        const getNotifications = createEndpoint<NotificationsResource>('notifications');

        try {
            const user = await getUser();
            userStore.$patch({user: user});
        } catch (e) {
            console.error('Cannot fetch User context');
        }

        try {
            const notifications = await getNotifications();
            notificationsStore.notificationsRecord = notifications;
        } catch (e) {
            console.error('Cannot fetch Notifications context');
        }
    },
});
